/**
 * Les mots du cadre de l'app : les boutons du bas au téléphone, l'Aide, le compte, et les mots
 * d'un projet au téléphone.
 */

/**
 * Le cadre du téléphone (chantier `telephone-cadre`, ticket 01, `design/telephone.html`) : les
 * cinq boutons du bas, Maintenant, Projets, +, Agenda, Journée, et les Paramètres qu'ouvre ⚙.
 */
export const MAINTENANT = 'Maintenant';
export const JOURNEE = 'Journée';
export const PROJETS = 'Projets';
export const AGENDA = 'Agenda';
export const PARAMETRES = 'Paramètres';
export const AIDE = 'Aide';
/**
 * La barre de gauche de l'ordinateur (chantier `navigation`, 01, maquette du carnet
 * `accueil.html`) : le nom de l'app, les pages, et les deux qui viennent avec leurs chantiers.
 */
export const NEXTILT = 'Nextilt';
export const TABLEAU_DE_BORD = 'Tableau de bord';
export const RESSOURCES = 'Ressources';
export const PROFIL = 'Profil';
export const BIENTOT = 'Bientôt';
export const LES_PAGES = 'Les pages';
/**
 * L'en-tête de la liste de l'Aide (chantier `aide`, ticket 01) : chaque partie se joue sur le
 * voyage de démo, qui part quand elle se termine ; la présentation, seule, fait créer son
 * propre projet. Plus de durée promise : la présentation prend plus d'une ou deux minutes.
 */
export const EN_TETE_DE_L_AIDE =
  'Choisis un geste : il se fait sur un projet de démo, « Préparer un voyage », effacé à la fin. La présentation, elle, te fait créer le tien.';
/**
 * L'Aide de l'ordinateur décrit l'app d'avant le carnet : dit en tête, le temps de sa
 * reconstruction (chantier en attente `aide-du-carnet` ; choix C d'Igor avant la mise en ligne,
 * 2026-10-21).
 */
export const AIDE_EN_REECRITURE =
  'L’Aide est en cours de réécriture pour le nouveau carnet : certains écrans ont changé. Ce qu’elle dit du fonctionnement (les états, les attentes, ce que tu peux faire maintenant) reste vrai.';
export const GESTES_DU_TELEPHONE = 'Les gestes du téléphone';

/**
 * Un projet au téléphone (ticket 05 du chantier `telephone`) : le fil de la racine d'un projet ramène à « Mes projets »,
 * et le rond de la Liste coche (« C'est fait ») ou défait (« Annuler »), comme la fiche.
 */
export const MES_PROJETS = 'Mes projets';
export const ROND_COCHE = 'Toucher : c’est fait';
export const ROND_DECOCHE = 'Toucher : annuler, remettre à faire';
/** Sur ordinateur, le titre du rond nomme l'état d'où l'on part et celui où l'on arrive. */
export const rondQuiTourne = (de: string, vers: string) => `${de} — cliquer pour passer à « ${vers} »`;
export const MON_COMPTE = 'Mon compte';
export const COMPTE_SANS_EMAIL = 'Compte sans e-mail';
export const SORTIR = 'Sortir';
/** Le bouton qui replie la barre de gauche en rail d'icônes, et la rouvre (chantier `barre-repliable`). */
export const REPLIER_LA_BARRE = 'Replier la barre';
export const DEPLIER_LA_BARRE = 'Déplier la barre';
export const RETOUR = 'Retour';

/*
 * Le haut des écrans du téléphone en carnet (chantier telephone-habit, 02, maquette
 * `app-au-telephone.html`, `haut()`, `engrenage()`, `feuilleHtml()`) : l'initiale ouvre les
 * Paramètres de l'app ; le ⚙, sur Maintenant, la Journée et un projet ouvert, règle cet écran.
 * Les petits mots (« pour cet écran seulement », « l'app ») s'écrivent en minuscules à l'écran.
 */
export const REGLER_CET_ECRAN = 'Régler cet écran';
export const REGLER_MAINTENANT = 'Régler Maintenant';
export const REGLER_MA_JOURNEE = 'Régler ma journée';
export const REGLER_LE_PROJET = 'Régler le projet';
export const POUR_CET_ECRAN_SEULEMENT = 'Pour cet écran seulement';
export const TOUS_LES_PARAMETRES_DE_L_APP = 'Tous les paramètres de l’app';
export const L_APP = 'L’app';
export const CLAUDE_BRANCHE = 'Claude branché';
export const LA_FICHE_DU_PROJET = 'La fiche du projet';
export const PROJET_EN_TETE = 'Projet';

/*
 * L'Aide du téléphone (ticket 14 de telephone, maquette validée, forme 2 « un geste à la
 * fois ») : les dix sujets à la suite. Leurs textes sont dans `aideDuTelephone.ts`.
 */
export const PRECEDENT = 'Précédent';
export const SUIVANT = 'Suivant';
export const C_EST_COMPRIS = 'C’est compris';
/** « 3 sur 10 » : où l'on est dans l'Aide du téléphone. */
export function rangSurTotal(rang: number, total: number): string {
  return `${rang} sur ${total}`;
}
